// Lets Tournament.js tell TournamentHeader.js "the hero cover photo just
// scrolled out of reach, fade in the crest+title in its place" - mirrors
// compactSearchBus's role for the list pages' search toolbar, just for the
// tournament page's hero cover instead. `progress` is 0 (hero fully
// visible) to 1 (hero fully scrolled away), driven every scroll frame by
// useTournamentHeroCollapse - not a boolean, so the crossfade tracks the
// scroll gesture 1:1 instead of firing a fixed-duration CSS transition out
// of step with it.
export const tournamentHeroSubscribers = new Set();

export const publishTournamentHero = (progress) => {
    tournamentHeroSubscribers.forEach(cb => cb(progress));
};
